import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { Testimonials, ClientLogos } from '../../components'

const meta = {
	description: 'Accept in-store payments for your digital services.1,500+ retailer locations. Pay in-store. Secure and irreversible. Become a retailer, earn commission. Become a partner, expand your reach.',
	image: '/images/new/misc/blueshyft-meta.png',
	title: 'blueshyft | In-store payment gateway built for digital services',
	url: 'http://blueshyft.com.au',
};

import '../../css/homepage.css';

const TrustedBy = () => (
	<section className="trusted-by">
		<div className="trusted-by-logos marquee">
				<img src="/images/new/logos/trusted/1.svg"/>
				{/* <img src="/images/new/logos/trusted/2.svg"/> */}
				<img src="/images/new/logos/trusted/3.svg"/>
				{/* <img src="/images/new/logos/trusted/4.svg"/> */}
				{/* <img src="/images/new/logos/trusted/5.svg"/> */}
				{/* <img src="/images/new/logos/trusted/8.svg"/> */}
				<img src="/images/new/logos/trusted/10.svg"/>
				<img src="/images/new/logos/trusted/6.svg"/>
				{/* <img src="/images/new/logos/trusted/7.svg"/> */}
				{/* <img src="/images/new/logos/trusted/9.svg"/> */}
				<img src="/images/new/logos/trusted/11.svg"/>
			
		</div>

		<div className="trusted-by-logos-mobile">
				<img src="/images/new/logos/trusted/mobile/1.svg"/>
				{/* <img src="/images/new/logos/trusted/mobile/2.svg"/> */}
				<img src="/images/new/logos/trusted/mobile/3.svg"/>
				{/* <img src="/images/new/logos/trusted/mobile/4.svg"/> */}
				{/* <img src="/images/new/logos/trusted/mobile/5.svg"/> */}
				{/* <img src="/images/new/logos/trusted/mobile/8.svg"/> */}
				<img src="/images/new/logos/trusted/mobile/10.svg"/>
				<img src="/images/new/logos/trusted/mobile/6.svg"/>
				{/* <img src="/images/new/logos/trusted/mobile/7.svg"/> */}
				{/* <img src="/images/new/logos/trusted/mobile/9.svg"/> */}
				<img src="/images/new/logos/trusted/11.svg"/>
		</div>
	</section>
);

const WhatWeDo = () => (
	<section className="what-we-do">

				<div className="container">
			
						<h3 className="appear">What we do</h3>
						<p className="appear">The blueshyft network allows your customers to make over-the-counter payments to:</p>
						
						<div className="intro-icons appear">

								<div>
								<img src="/images/new/icons/wallet-blue.svg" className="what-we-do-icon" />
								<p>Load their digital wallet</p>
								</div>
								
								<div>
								<img src="/images/new/icons/dollar-blue.svg" className="what-we-do-icon" />
								<p>Credit their online account</p>
								</div>
								
								<div>
								<img src="/images/new/icons/card-blue.svg" className="what-we-do-icon" />
								<p>Pay for online orders</p>
								</div>

								<div>
								<img src="/images/new/icons/gift-blue.svg" className="what-we-do-icon" />
								<p>Purchase or redeem gift cards</p>
								</div>

						</div>

				</div>
			
		</section>
);

const Platform = () => (
	<section className="platform no-scale">

		<div className="container">

				<img src="/images/new/misc/arrow.svg" className="arrow"/>

				<div className="text">

						<h3>The platform</h3>
						<p>An iPad running a native iOS app is installed in all blueshyft locations. 
						This is the physical interaction point for your customers.</p>

				</div>

				<div className="image ">
					<div src="/images/new/misc/ipad-small.png" className="ipad"></div>
				</div>

		</div>

	</section>
);

const MobilePlatform = () => (
	<section className="mobile-platform">

		<div className="mobile-text">
				<h3>The platform</h3>
		</div>

		<div className="mobile-image" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
				<img src="/images/new/misc/mobile-ipad-new.png" className="mobile-ipad"/>
		</div>

		<div className="mobile-p">
				<p>An iPad running a native iOS app is installed in all blueshyft locations. 
				This is the physical interaction point for your customers.</p>
		</div>

	</section>
);

const Main = () => (
	<main className="wrapper">

		<section className="how-it-works section static">

				<div className="container">

						<h3>How it works</h3>
						<p className="how-it-works-intro">Your customers can deposit directly into their 
						online accounts at 1,500+ retail locations across Australia.</p>
						<p>Here's an example of what the typical user journey looks like:</p>


						<div className="diagram ">

								<div className="step ">
										<img src="/images/new/misc/how-1.svg" className="how-it-works-icon"/>
										<p>Customer downloads or logs into your smartphone app</p>
								</div>
								
								<div className="step">
										<img src="/images/new/misc/how-2.svg" className="how-it-works-icon"/>
										<p>Customer selects deposit amount and generates unique QR code</p>
										
								</div>
							
								<div className="step">
										<img src="/images/new/misc/how-3.svg" className="how-it-works-icon"/>
										<p>Customer uses in-app map to find nearest blueshyft deposit location</p>
								</div>
				
							
								<div className="step">
										<img src="/images/new/misc/how-4.svg" className="how-it-works-icon"/>
										<p>Customer scans their QR code on the in-store blueshyft iPad</p>
								</div>


							
								<div className="step">
										<img src="/images/new/misc/how-5.svg" className="how-it-works-icon"/>
										<p>Merchant verifies their details and customer pays with cash (or card)</p>
										
								</div>
						
								<div className="step">
										<img src="/images/new/misc/how-6.svg" className="how-it-works-icon"/>
										<p>Customer’s online account is instantly credited!</p>
									
								</div>
							
						</div>

				</div>

		</section>


		<section className="network section parallax">

						<div className="content">

								<h3>The network</h3>
								{/* <p>blueshyft is one of the largest retail networks in Australia, 
								comprised of over 1,500+ local retailers supported by a dedicated in-house team. 
								With deep local and retail experience, our network offers unparalleled reach.</p> */}

								<div className="browse-network">

										<div className="intro">
												<h6>Nation-wide and growing fast</h6>
												<p>You could switch on 1,500+ retail locations for your business, overnight.</p>
										</div>

										<div className="link">
												<a href="https://locations.blueshyft.com.au" target="_blank" className="browse-button">BROWSE NETWORK</a>
										</div>

								</div>

						</div>

		</section>

	</main>
);

const WillLove = ({ sliderSelected, changeSelection }) => (
	<section className="will-love">

		<div className="container">

				<div className="slider">
						<div className={`selector ${sliderSelected === 'business' ? 'business' : ''}`}></div>
						<h4 className={sliderSelected === 'customers' ? 'selected' : ''} onClick={() => changeSelection('customers')}>YOUR CUSTOMERS WILL LOVE</h4>
						<h4 className={sliderSelected === 'business' ? 'selected' : ''} onClick={() => changeSelection('business')}>YOUR BUSINESS WILL LOVE</h4>
				</div>

				<SliderSection className="customer benefits" active={sliderSelected === 'customers'}>

						<div className="benefit">
								<img src="/images/new/icons/map-white.svg" className="will-love-icon"/>
								<p>1,500+ convenient locations</p>
						</div>
						
						<div className="benefit">
								<img src="/images/new/icons/wallet-white.svg" className="will-love-icon"/>
								<p>Cash payments and top ups</p>
						</div>
						
						<div className="benefit">
								<img src="/images/new/icons/id-white.svg" className="will-love-icon"/>
								<p>In-store activation (with ID check)</p>
						</div>
								
						<div className="benefit">
								<img src="/images/new/icons/gift-white.svg" className="will-love-icon"/>
								<p>Stored value and gift cards</p>
						</div>
						<div className="benefit">
								<img src="/images/new/icons/folders-white.svg" className="will-love-icon"/>
								<p>Interactive online directories</p>
						</div>
								
						<div className="benefit">
								<img src="/images/new/icons/globe-white.svg" className="will-love-icon"/>
								<p>Product launches nation-wide</p>
						</div>

				</SliderSection>

				<SliderSection className="business benefits" active={sliderSelected === 'business'}>

						<div className="benefit">
								<img src="/images/new/icons/dollar-white.svg" className="will-love-icon"/>
								<p>A platform with experience in processing millions of unique transactions</p>
						</div>
								
						<div className="benefit">
								<img src="/images/new/icons/cross-white.svg" className="will-love-icon"/>
								<p>Protection against fraudulent payments with irreversible deposits</p>
						</div>
								
						<div className="benefit">
								<img src="/images/new/icons/cog-white.svg" className="will-love-icon"/>
								<p>Optional security features available, including in-store 2FA</p>
						</div>
										
						<div className="benefit">
								<img src="/images/new/icons/promote-white.svg" className="will-love-icon"/>
								<p>In-store marketing opportunities reaching 500,000+ customers daily</p>
						</div>

				</SliderSection>

		</div>

	</section>
);

const AsSeenIn = () => (
	<section className="as-seen-in">

				<div className="container">

						<h3>As seen in...</h3>

						<div className="mastheads">
								
										<a href="https://www.afr.com/technology/bitcoin-available-over-the-counter-at-a-newsagency-near-you-20160527-gp52ka"target="_blank"><img src="/images/new/misc/mastheads/masthead-1.svg"/></a>
										<a href="https://techinvest.online/now-anyone-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/masthead-2.svg"/></a>
										<a href="http://www.theaustralian.com.au/business/media/digital/newsagents-shift-into-digital-dealing-no-blue-with-blueshyft/news-story/f67b6f840398cf46fb66fc806f0e8af1/"target="_blank"><img src="/images/new/misc/mastheads/masthead-3.svg"/></a>
										<a href="https://mashable.com/2016/06/02/bitcoin-newsagency-australia/?utm_cid=mash-com-Tw-main-link#8FvnroTuusq4"target="_blank"><img src="/images/new/misc/mastheads/masthead-4.svg"/></a>
										<br/>
										<a href="https://www.news.com.au/finance/money/aussies-will-be-able-to-play-some-of-the-worlds-biggest-lotteries-from-newsagents/news-story/73e745f67d71617eab0a578363916ef3"target="_blank"><img src="/images/new/misc/mastheads/news.svg"/></a>
										<a href="https://www.econotimes.com/Bitcoincomau-launched-officially-in-Australia-217586"target="_blank"><img src="/images/new/misc/mastheads/econotimes.svg"/></a>
										<a href="https://www.themartec.com/insidelook/50-top-startups-sydney"target="_blank"><img src="/images/new/misc/mastheads/masthead-5.svg"/></a>
										<a href="https://australianfintech.com.au/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/masthead-6.png"/></a>
										<a href="https://coinreport.net/bitcoin-now-available-australian-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/masthead-7.svg"/></a>
										<br/>
										<a href="https://bravenewcoin.com/insights/blueshyft-and-bitcoin-australia-partner-to-sell-bitcoin-over-the-counter-at-1200-newsagency-shops"target="_blank"><img src="/images/new/misc/mastheads/brave.svg"/></a>
										<a href="https://themerkle.com/australians-can-now-purchase-bitcoin-with-cash-at-1200-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/masthead-8.svg"/></a>    
										<a href="https://news.bitcoin.com/australian-newsstands-bitcoin-counter/"target="_blank"><img src="/images/new/misc/mastheads/masthead-9.svg"/></a>
										<a href="https://www.coinspeaker.com/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/coinspeaker.svg"/></a>

						</div>

						<div className="tablet-mastheads">

										<a href="https://www.afr.com/technology/bitcoin-available-over-the-counter-at-a-newsagency-near-you-20160527-gp52ka"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-1.svg"/></a>
										<a href="https://mashable.com/2016/06/02/bitcoin-newsagency-australia/?utm_cid=mash-com-Tw-main-link#8FvnroTuusq4"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-2.svg"/></a>
										<a href="http://www.theaustralian.com.au/business/media/digital/newsagents-shift-into-digital-dealing-no-blue-with-blueshyft/news-story/f67b6f840398cf46fb66fc806f0e8af1/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-3.svg"/></a>
										<a href="https://techinvest.online/now-anyone-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-4.svg"/></a>
										<a href="https://www.news.com.au/finance/money/aussies-will-be-able-to-play-some-of-the-worlds-biggest-lotteries-from-newsagents/news-story/73e745f67d71617eab0a578363916ef3"target="_blank"><img src="/images/new/misc/mastheads/tablet/news.svg"/></a>
										<a href="https://www.econotimes.com/Bitcoincomau-launched-officially-in-Australia-217586"target="_blank"><img src="/images/new/misc/mastheads/tablet/econotimes.svg"/></a>
										<a href="https://www.themartec.com/insidelook/50-top-startups-sydney"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-5.svg"/></a>
										<a href="https://coinreport.net/bitcoin-now-available-australian-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-6.svg"/></a>
										<a href="https://bravenewcoin.com/insights/blueshyft-and-bitcoin-australia-partner-to-sell-bitcoin-over-the-counter-at-1200-newsagency-shops"target="_blank"><img src="/images/new/misc/mastheads/tablet/brave.svg"/></a>
										<a href="https://australianfintech.com.au/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-7.png"/></a>
										<a href="https://themerkle.com/australians-can-now-purchase-bitcoin-with-cash-at-1200-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-8.svg"/></a>    
										<a href="https://news.bitcoin.com/australian-newsstands-bitcoin-counter/"target="_blank"><img src="/images/new/misc/mastheads/tablet/masthead-9.svg"/></a>
										<a href="https://www.coinspeaker.com/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/tablet/coinspeaker.svg"/></a>

						</div>

						<div className="mobile-mastheads">
						
										<a href="https://www.afr.com/technology/bitcoin-available-over-the-counter-at-a-newsagency-near-you-20160527-gp52ka"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-1.svg"/></a>
										<a href="https://techinvest.online/now-anyone-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-2.svg"/></a>
										<a href="http://www.theaustralian.com.au/business/media/digital/newsagents-shift-into-digital-dealing-no-blue-with-blueshyft/news-story/f67b6f840398cf46fb66fc806f0e8af1/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-3.svg"/></a>
										<a href="https://mashable.com/2016/06/02/bitcoin-newsagency-australia/?utm_cid=mash-com-Tw-main-link#8FvnroTuusq4"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-4.svg"/></a>
										<a href="https://www.news.com.au/finance/money/aussies-will-be-able-to-play-some-of-the-worlds-biggest-lotteries-from-newsagents/news-story/73e745f67d71617eab0a578363916ef3"target="_blank"><img src="/images/new/misc/mastheads/mobile/news.svg"/></a>
										<a href="https://www.econotimes.com/Bitcoincomau-launched-officially-in-Australia-217586"target="_blank"><img src="/images/new/misc/mastheads/mobile/econotimes.svg"/></a>
										<a href="https://www.themartec.com/insidelook/50-top-startups-sydney"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-5.svg"/></a>
										<a href="https://australianfintech.com.au/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-6.png"/></a>
										<a href="https://bravenewcoin.com/insights/blueshyft-and-bitcoin-australia-partner-to-sell-bitcoin-over-the-counter-at-1200-newsagency-shops"target="_blank"><img src="/images/new/misc/mastheads/mobile/brave.svg"/></a>
										<a href="https://coinreport.net/bitcoin-now-available-australian-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-7.svg"/></a>
										<a href="https://themerkle.com/australians-can-now-purchase-bitcoin-with-cash-at-1200-newsstands/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-8.svg"/></a>    
										<a href="https://news.bitcoin.com/australian-newsstands-bitcoin-counter/"target="_blank"><img src="/images/new/misc/mastheads/mobile/masthead-9.svg"/></a>
										<a href="https://www.coinspeaker.com/now-can-buy-ethereum-alt-coins-cash-local-newsagent/"target="_blank"><img src="/images/new/misc/mastheads/mobile/coinspeaker.svg"/></a>
						
						</div>

				</div>

		</section>
);

export default class Home extends Component {
	state = {
		sliderSelected: 'customers',
		load: 0,
	}

	changeSelection = (sel) => {
		this.setState({sliderSelected: sel})
	}

	render () {
		if (this.state.load < 10) {
			setTimeout(() => {
				this.setState({ load: this.state.load + 1 });
			}, 500);
		}

		const { sliderSelected } = this.state

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<TrustedBy />
				{ this.state.load > 1 ? <WhatWeDo /> : null }
				{ this.state.load > 2 ? <Platform /> : null }
				{ this.state.load > 3 ? <MobilePlatform /> : null }
				{ this.state.load > 4 ? <Main /> : null }
				{ this.state.load > 5 ? <WillLove sliderSelected={sliderSelected} changeSelection={this.changeSelection} /> : null }
				{ this.state.load > 6 ? <ClientLogos /> : null }
				{ this.state.load > 7 ? <Testimonials /> : null }
				{ this.state.load > 8 ? <AsSeenIn /> : null }

			</React.Fragment>
		);
	}
};

const SliderSection = styled.div`
	display: ${props => props.active ? 'flex' : 'none'} !important;

`


// WEBPACK FOOTER //
// ./client/scenes/Home/index.js